import { FALLBACK_PRODUCT_IMAGE } from '../../config/constants';

export default {
  name: 'ExchangeLineItem',
  props: {
    heading: {
      type: String,
      default: '',
    },
    productImage: {
      type: String,
      default: '',
    },
    productDisplayName: {
      type: String,
      default: '',
    },
    productPartNumber: {
      type: String,
      default: '',
    },
    headingIconClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    getProductImage() {
      return this.productImage || FALLBACK_PRODUCT_IMAGE;
    },
  },
};
